import { render } from "./DefaultView.vue?vue&type=template&id=1b62fd9b&scoped=true"
import script from "./DefaultView.vue?vue&type=script&lang=js"
export * from "./DefaultView.vue?vue&type=script&lang=js"

import "./DefaultView.vue?vue&type=style&index=0&id=1b62fd9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b62fd9b"]])

export default __exports__